function createRowHighlighter({ getContainer, getRows, duration = 1000 }) {
  const pending = new Map()
  const timers = new Map()
  const originalStyles = new WeakMap()

  function restoreCell(cell) {
    const original = originalStyles.get(cell)
    if (!original) return
    if (original.value) {
      cell.style.setProperty('background-color', original.value, original.priority)
    } else {
      cell.style.removeProperty('background-color')
    }
    originalStyles.delete(cell)
  }

  function apply() {
    const container = getContainer()
    const rows = getRows() || []
    if (!container || !container.querySelectorAll) return
    const now = Date.now()
    container.querySelectorAll('td[data-y]').forEach(cell => {
      const row = rows[Number(cell.getAttribute('data-y'))]
      const expiresAt = row && pending.get(String(row.id))
      if (expiresAt && expiresAt > now) {
        if (!originalStyles.has(cell)) {
          originalStyles.set(cell, {
            value: cell.style.getPropertyValue('background-color'),
            priority: cell.style.getPropertyPriority('background-color')
          })
        }
        cell.style.setProperty('background-color', '#bbf7d0', 'important')
      } else {
        restoreCell(cell)
      }
    })
  }

  function mark(id) {
    if (id === undefined || id === null) return
    const key = String(id)
    pending.set(key, Date.now() + duration)
    if (timers.has(key)) clearTimeout(timers.get(key))
    timers.set(key, setTimeout(() => {
      pending.delete(key)
      timers.delete(key)
      apply()
    }, duration))
    apply()
  }

  function clear() {
    timers.forEach(timer => clearTimeout(timer))
    timers.clear()
    pending.clear()
    apply()
  }

  return { mark, apply, clear, pending }
}

module.exports = { createRowHighlighter }
